import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { partial } from '../../../util/translation/translation';
import renderField from '../../../shared/components/custom/Field';
import { connect } from 'react-redux';
import validateEmailInvite from './validateEmailInvite';
import { toast } from 'react-toastify';
import Api from '../../../util/api';
import Loading from '../../../shared/components/custom/Loading';
import useConfig from '../../../util/useConfig';
import {
  bookingTotal,
  eventCurrency,
  formatMoney,
  isPaidEvent,
  krInputToOre,
  paymentErrorMessage,
} from '../payments';

const EmailInviteModal = ({ formValues, event }) => {
  const p = partial('EventParticipantsPage');
  const ep = partial('EventPayments');
  const s = partial('shared');
  const config = useConfig();
  const currency = eventCurrency(event, config);
  // On a paid event the invite has a price (0 = free), the event's to start
  const paid = isPaidEvent(event);

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    if (paid) {
      const priceError = validateEmailInvite(values || {});
      if (priceError.price || priceError.bookingFee) {
        toast.error(priceError.price || priceError.bookingFee);
        return;
      }
    }
    try {
      setLoading(true);
      const payload = {
        email: values.email,
        maxGuests: values.maxGuestAmount,
        ...(paid && {
          price: krInputToOre(values.price) || 0,
          bookingFee: krInputToOre(values.price)
            ? krInputToOre(values.bookingFee) || 0
            : 0,
        }),
      };
      await Api.events.sendEmailInvite(event.id, payload);
      toast.success(p('emailInviteSuccess'));
    } catch (err) {
      toast.error(
        paymentErrorMessage(err, 'EventParticipantsPage.inviteNotSent')
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <form
      className="form invite-modal__form"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(formValues);
      }}
    >
      <Loading loading={loading} />
      <div className="form__form-group">
        <span className="form-header">{s('email')}</span>
        <Field
          name="email"
          placeholder={s('email')}
          component={renderField}
          type="email"
        />
      </div>
      <div className="form__form-group">
        <span className="form-header">{p('numberOfGuests')}</span>
        <Field
          name="maxGuestAmount"
          placeholder={p('chooseGuests')}
          disabled={!formValues?.email}
          component={renderField}
          type="number"
        />
      </div>
      {paid && (
        <>
          <div className="form__form-group">
            <span className="form-header">
              {ep('pricePerPlace', { currency })}
            </span>
            <Field
              name="price"
              placeholder={ep('free')}
              component={renderField}
              inputMode="decimal"
            />
          </div>
          <div className="form__form-group">
            <span className="form-header">
              {ep('bookingFee', { currency })}
            </span>
            <Field
              name="bookingFee"
              placeholder="0"
              component={renderField}
              inputMode="decimal"
              disabled={!krInputToOre(formValues?.price)}
            />
          </div>
          <small className="invite-modal__field-hint invite-modal__full">
            {krInputToOre(formValues?.price)
              ? ep('invitePriceHint', {
                  example: formatMoney(
                    bookingTotal(
                      2,
                      krInputToOre(formValues?.price),
                      krInputToOre(formValues?.bookingFee)
                    ),
                    currency
                  ),
                })
              : ep('inviteFreeHint')}
          </small>
        </>
      )}
      <div className="invite-modal__footer">
        <Button
          color="primary"
          type="submit"
          size="sm"
          className="mb-0"
          disabled={loading || !formValues?.email}
        >
          {p('sendInvite')}
        </Button>
      </div>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'EmailInviteModal',
  validate: validateEmailInvite,
});

const mapStateToProps = (state) => ({
  formValues: getFormValues('EmailInviteModal')(state),
});

export default connect(mapStateToProps)(reduxF(EmailInviteModal));
